module.exports = __webpack_public_path__ + "static/media/zurich.2e64a1a2.svg";